import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../../Layout/Main/header/Header";
import Footer from "../../../Layout/Main/footer/FooterTwo";
import AboutTwo from "./AboutTwo";
import { Link } from "react-router-dom";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { withStyles,makeStyles,useStyles } from '@material-ui/styles'
import {Col,Form,Button} from 'react-bootstrap';

const styles = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        
      },
      paper: {
        border: '2px solid #000',
        backgroundColor:'white',
        width:'100vh',
        height:'70vh'
      },
});

const Content = [
{
    subTitle: 'Make a checklist of your items',
    Content: 'First, make a checklist of what household items you required. Everyone"s list is different because it all depends on how much time do you have. Some people have two months for packing while some have only two weeks. So, arrange your checklist accordingly.',
    id: 1
},
{
    subTitle: 'Categorize so you can pick less',
    Content: 'A crucial packing tip is to make a list of things you do not need. You can lighten your stress and workload by sell or donate all the stuff you no longer need. Measure the new place where you are going and get rid of all furniture that will not fit in your new location.',
    id: 2
},
{
    subTitle: 'Purchase some quality moving boxes',
    Content: 'If you want to put heavy things in boxes, then buy boxes of good quality, so they do not fall apart in your hands while you are trying to move it into other places. Grocery boxes or reused boxes can be compromised due to moisture.',
    id: 3
},
{
    subTitle: 'First pack essential things',
    Content: 'When you are moving to a new place first pack the things which you needed most, because all the boxes contain the same color, so you do not mix the essential stuff.',
    id: 4
},
{
    subTitle: 'Use the color packing label.',
    Content: 'To stay organized, use the color label and put it on boxes. This moving tip can save your ton of time. You do not have to get panic for finding the important material. ',
    id: 5
},
{
    subTitle: 'Do not overload your moving box',
    Content: 'A lot of people made a massive mistake while moving; they cram all their belongings in a few boxes and overload them. As a result, the box itself unbox in your hand. Use as many boxes as you need to create easy-to-lift loads. Try to keep your most jumbo boxes to not more than fifty pounds.',
    id: 6
},
{
    subTitle: 'Use the right box for the right material',
    Content: 'Put heavy material like books in small boxes and light things in large boxes to make it easier for the mover to organize and pack all boxes in the moving truck. Make sure to put heavier items on the bottom and the lighter one on the top to avoid damaging the fragile items.',
    id: 7
},
{
    subTitle: 'Fill all the spaces in the box',
    Content: 'After putting all the material in the box, if the small spaces left then, fill that spaces with packing paper, clothing or form, peanuts, etc. Use tape at the bottom and top of the box. You can also use tape in places where stress is concentrated.',
    id: 8
},


];
class Tips extends Component{
    constructor(props) {
        super(props);
        this.state = { OpenModal: false };
    }
    handleOpen = () => {
        this.setState({OpenModal:true});
      };
    handleClose = () => {
        this.setState({OpenModal:false});
      };
    render(){
        const { classes } = this.props;
        let title = 'Useful Articles to Read ';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Moving in Bad Weather' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                {/* <Breadcrumb title={'Blog'}   /> */}
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="containerBlog">
                            <div className="col-12 text-center ptb--50">
                                <h1>Useful Articles to Read</h1>
                            </div>
                            <div className="row row--35">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                
                                <div className="col-lg-8 text-center pt--20">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                           
                                        </div>
                                        <div className="row creative-service">
                                            <div className="col-lg-12">
                                                <AboutTwo item="8" column="col-lg-6 col-md-12 col-sm-12 col-12 text-left" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 text-center">
                                    <div className="about-inner">
                                       <div className="row scrollbarNav" style={{maxHeight:'900px',overflowY:'auto'}}>
                                           
                                            <div className="col-12 pt--30" style={{textAlign:' -webkit-center'}} >
                                                <div className="Card"style={{boxShadow: 'grey 0px 0px 32px -7px',width:'300px',borderRadius:'10px',padding:'25px'}}>
                                                    <a href="/reliablemove">
                                                        <img width="160px"  src={require('../../../assets/icon3.jpeg')} />
                                                        <h3 style={{textAlign: '-webkit-center'}}>Reliable Move</h3>
                                                        <p style={{textAlign: '-webkit-left',paddingLeft:'10px'}}>
                                                            You could never be sure what type of movers you’ll stumble
                                                            across when you’re changing your home.          
                                                        </p>
                                                    </a>
                                                </div>
                                            </div>
                                            
                                            <div className="col-12 pt--30" style={{textAlign:' -webkit-center'}} >
                                                <div className="Card"style={{boxShadow: 'grey 0px 0px 32px -7px',width:'300px',borderRadius:'10px',padding:'25px'}}>
                                                    <a href="/badweather">
                                                        <img width="160px"  src={require('../../../assets/icon4.jpeg')} />
                                                        <h3 style={{textAlign: '-webkit-center'}}>Bad Weather</h3>
                                                        <p style={{textAlign: '-webkit-left',paddingLeft:'10px'}}>
                                                            Not everyone has the luxury of being able to move 
                                                            when it's nice and sunny outside         
                                                        </p>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-12 pt--30" style={{textAlign:' -webkit-center'}} >
                                                <div className="Card"style={{boxShadow: 'grey 0px 0px 32px -7px',width:'300px',borderRadius:'10px',padding:'25px'}}>
                                                    <a href="/movingchecklist">
                                                        <img width="160px"  src={require('../../../assets/icon5.jpeg')} />
                                                        <h3 style={{textAlign: '-webkit-center'}}>Moving Checklist</h3>
                                                        <p style={{textAlign: '-webkit-left',paddingLeft:'10px'}}>
                                                            While moving to a new place can be fun, we 
                                                            all know that the moving process itself can cause a lot of stress          
                                                        </p>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-12 pt--30" style={{textAlign:' -webkit-center'}} >
                                                <div className="Card"style={{boxShadow: 'grey 0px 0px 32px -7px',width:'300px',borderRadius:'10px',padding:'25px'}}>
                                                    <a href="/movingguide">
                                                        <img width="160px"  src={require('../../../assets/icon3.jpeg')} />
                                                        <h3 style={{textAlign: '-webkit-center'}}>Moving Guide</h3>
                                                        <p style={{textAlign: '-webkit-left',paddingLeft:'10px'}}>
                                                            Are you faced with your first relocation? Then it’s not a surprise 
                                                            that you’re so confused and you have no idea what to do         
                                                        </p>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-12 pt--30" style={{textAlign:' -webkit-center'}} >
                                                <div className="Card"style={{boxShadow: 'grey 0px 0px 32px -7px',width:'300px',borderRadius:'10px',padding:'25px'}}>
                                                    <a href="/movingtips">
                                                        <img width="160px"  src={require('../../../assets/icon1.jpeg')} />
                                                        <h3 style={{textAlign: '-webkit-center'}}>Moving Tips</h3>
                                                        <p style={{textAlign: '-webkit-left',paddingLeft:'10px'}}>
                                                            You could never be sure what type of movers you’ll stumble
                                                            across when you’re changing your home.          
                                                        </p>
                                                    </a>
                                                </div>
                                            </div>
                                             
                                       </div>

                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                       <div className="col-12 text-center pt--30">
                                                <button id="BlogBtn" style={{fontSize: '22px', width: '35rem',height: '4rem'}} onClick={this.handleOpen}>What Topic do you want us to talk about?</button>
                                                <Modal
                                                aria-labelledby="transition-modal-title"
                                                aria-describedby="transition-modal-description"
                                                className={classes.modal}
                                                open={this.state.OpenModal}
                                                onClose={this.handleClose}
                                                closeAfterTransition
                                                BackdropComponent={Backdrop}
                                                BackdropProps={{
                                                timeout: 500,
                                                }}
                                            >
                                                <Fade in={this.state.OpenModal}>
                                                <div className={classes.paper}>
                                                    <div className="text-center">                                                    
                                                    <h3 style={{fontSize:'30px',marginTop:'2rem'}} id="transition-modal-title">What Topic do you want us to talk about?</h3>
                                                    </div>
                                                    <Form style={{paddingLeft:'18vh',paddingRight:'18vh'}}>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Name</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Name"  />
                                                        </Form.Group>

                                                        
                                                    </Form.Row>

                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control type="email" placeholder="Enter email" />
                                                        </Form.Group>

                                                       
                                                    </Form.Row>
                                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label>Details of Your Topic</Form.Label>
                                                        <Form.Control as="textarea" rows="3" />
                                                    </Form.Group>
                                                    

                                                    <div className="text-center pt--30">
                                                    <Button variant="primary" type="submit" style={{width:'13rem', border:'2px solid black',background:'#de2828'}}>
                                                        Submit
                                                    </Button>
                                                    </div>
                                                    </Form>
                                                </div>
                                                </Fade>
                                                </Modal>
                                            </div>
                                       </div>
                            
                        </div>
                    </div>
                </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default withStyles(styles)(Tips);